import { LOADING_MODAL, APPROVAL_LIST_LOADED, APPROVAL_USER_LOADED, APPROVAL_LOADING } from './approvalTypes'
import api from '../../services/api'
import { addErrorToast } from './companyActionCreators'

export const handleApprovalLoading = () => {
  return {
    type: APPROVAL_LOADING,
  }
}

export const handleCompanyModalLoading = () => {
  return {
    type: LOADING_MODAL,
  }
}

export const fetchOverrideDetails = (id) => async (dispatch) => {
  dispatch(handleCompanyModalLoading())

  try {
    const res = await api.get(`/approval/load/${id}`)
    if (res.ok) {
      const data = await res.json()
      dispatch(approvalUserLoaded(data))
    }
  } catch (e) {
    dispatch(addErrorToast(e))
  }
}

export const approvalUserLoaded = (payload) => {
  return {
    type: APPROVAL_USER_LOADED,
    payload: payload,
  }
}

export const approvalListLoaded = (payload) => {
  return {
    type: APPROVAL_LIST_LOADED,
    payload: payload,
  }
}

export const fetchApprovalList = () => async (dispatch) => {
  dispatch(handleApprovalLoading())

  try {
    const res = await api.get('/approval')
    if (res.ok) {
      const data = await res.json()
      dispatch(approvalListLoaded(data))
    }
  } catch (e) {
    dispatch(addErrorToast(e))
  }
}

export const handleApproveMultipleChanges = (selected) => async (dispatch) => {
  dispatch(handleApprovalLoading())

  try {
    const res = await api.post(`/approval/batchApprove`, selected)
    if (res.ok) {
      dispatch(fetchApprovalList())
    }
  } catch (e) {
    dispatch(addErrorToast(e))
  }
}
export const handleApproveChange = (row) => async (dispatch) => {
  dispatch(handleApprovalLoading())
  try {
    const res = await api.post(`/approval/approve/${row.id}`, {})
    if (res.ok) {
      dispatch(fetchApprovalList())
    }
  } catch (e) {
    dispatch(addErrorToast(e))
  }
}

export const handleOverrideChange = (row, reason, status, ignoreUntil, exclusions, excludedAgreement) => async (dispatch) => {
  dispatch(handleApprovalLoading())
  try {
      const res = await api.post(`/approval/override/${row.id}`, {
      reason: reason,
      status: status,
      ignoreUntil: ignoreUntil,
      exclusions: exclusions,
      excludedFromAgreement: excludedAgreement
    })
    if (res.ok) {
      dispatch(fetchApprovalList())
    }
  } catch (e) {
    dispatch(addErrorToast(e))
  }
}
